import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-success mb-3"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { for: "Name" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { for: "Email" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { for: "Name" }
const _hoisted_12 = { class: "dropdown-wrap unit-dropdown position-relative bg-white" }
const _hoisted_13 = { class: "mr-3" }
const _hoisted_14 = { class: "dropdown-actions" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_20 = { class: "align-text-top" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_23 = { class: "align-text-top" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { for: "Name" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-sm-8" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { class: "dropdown-wrap unit-dropdown position-relative bg-white" }
const _hoisted_30 = { class: "mr-3" }
const _hoisted_31 = { class: "dropdown-actions" }
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_34 = { class: "col-sm-4" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "col-md-6" }
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = {
  key: 1,
  class: "row"
}
const _hoisted_40 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_41 = { class: "time-slot-block mb-2" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { class: "row mt-2" }
const _hoisted_44 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_45 = { class: "text-success" }
const _hoisted_46 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_47 = { class: "text-danger" }
const _hoisted_48 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_49 = { class: "col-md-6" }
const _hoisted_50 = { class: "text-success" }
const _hoisted_51 = {
  key: 2,
  class: "remove-btn text-end"
}
const _hoisted_52 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_53 = { class: "modal-wrap default-modal" }
const _hoisted_54 = {
  class: "modal fade",
  id: "addNewmemberRole",
  "data-backdrop": "static",
  "data-keyboard": "false",
  tabindex: -1,
  "aria-labelledby": "hidePojectLabel",
  "aria-hidden": "true"
}
const _hoisted_55 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_56 = { class: "modal-content" }
const _hoisted_57 = { class: "modal-header" }
const _hoisted_58 = {
  key: 0,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_59 = {
  key: 1,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_60 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_61 = { class: "modal-body" }
const _hoisted_62 = { class: "form-group" }
const _hoisted_63 = { for: "" }
const _hoisted_64 = {
  key: 0,
  class: "form-group"
}
const _hoisted_65 = { for: "" }
const _hoisted_66 = { class: "inline-items" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { class: "align-text-top" }
const _hoisted_69 = {
  key: 1,
  class: "form-group"
}
const _hoisted_70 = { for: "" }
const _hoisted_71 = { class: "inline-items" }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { class: "align-text-top" }
const _hoisted_74 = { class: "modal-footer" }
const _hoisted_75 = { class: "modal-wrap default-modal" }
const _hoisted_76 = {
  class: "modal fade",
  id: "addNewAmountType",
  "data-backdrop": "static",
  "data-keyboard": "false",
  tabindex: -1,
  "aria-labelledby": "hidePojectLabel",
  "aria-hidden": "true"
}
const _hoisted_77 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_78 = { class: "modal-content" }
const _hoisted_79 = { class: "modal-header" }
const _hoisted_80 = {
  key: 0,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_81 = {
  key: 1,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_82 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_83 = { class: "modal-body" }
const _hoisted_84 = { class: "form-group" }
const _hoisted_85 = { for: "" }
const _hoisted_86 = { class: "form-group" }
const _hoisted_87 = { for: "" }
const _hoisted_88 = {
  value: "selected",
  disabled: true,
  selected: true
}
const _hoisted_89 = { class: "modal-footer" }
const _hoisted_90 = { class: "modal-wrap default-modal" }
const _hoisted_91 = {
  class: "modal fade",
  id: "deleteRoleModel",
  "data-backdrop": "static",
  "data-keyboard": "false",
  tabindex: -1,
  "aria-labelledby": "addFavPojectLabel",
  "aria-hidden": "true"
}
const _hoisted_92 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_93 = { class: "modal-content" }
const _hoisted_94 = { class: "modal-header" }
const _hoisted_95 = {
  class: "modal-title",
  id: "addFavPojectLabel"
}
const _hoisted_96 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_97 = { class: "modal-body" }
const _hoisted_98 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_99 = { class: "modal-footer" }
const _hoisted_100 = { class: "modal-wrap default-modal" }
const _hoisted_101 = {
  class: "modal fade",
  id: "deleteAmountTypeModel",
  "data-backdrop": "static",
  "data-keyboard": "false",
  tabindex: -1,
  "aria-labelledby": "addFavPojectLabel",
  "aria-hidden": "true"
}
const _hoisted_102 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_103 = { class: "modal-content" }
const _hoisted_104 = { class: "modal-header" }
const _hoisted_105 = {
  class: "modal-title",
  id: "addFavPojectLabel"
}
const _hoisted_106 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_107 = { class: "modal-body" }
const _hoisted_108 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_109 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.members, (member, memberIndex) => {
      return (_openBlock(), _createBlock("div", {
        class: "border p-3 rounded mb-3 bg-light",
        key: `existing${memberIndex}`
      }, [
        (member.isExist)
          ? (_openBlock(), _createBlock("p", _hoisted_1, _toDisplayString(_ctx.$t('already_existed_member_with_invitation_accepted')) + " !!!", 1))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('enter_name')), 1),
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": ($event: any) => (member.name = $event)
              }, null, 8, ["onUpdate:modelValue"]), [
                [_vModelText, member.name]
              ])
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('enter_email_address')), 1),
              _withDirectives(_createVNode("input", {
                type: "email",
                class: "form-control",
                "onUpdate:modelValue": ($event: any) => (member.email = $event)
              }, null, 8, ["onUpdate:modelValue"]), [
                [_vModelText, member.email]
              ])
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('select_role')), 1),
              _createVNode("div", _hoisted_12, [
                _createVNode("a", {
                  class: "dropdown-toggle d-block border rounded py-2 px-3",
                  type: "button",
                  "data-toggle": "dropdown",
                  "aria-expanded": "false",
                  disabled: _ctx.state.ui.isLoading.isShow
                }, [
                  _createVNode("span", _hoisted_13, _toDisplayString(member.role.id
                ? member.role.name
                : _ctx.$t('choose_role')), 1)
                ], 8, ["disabled"]),
                _createVNode("div", {
                  class: "dropdown-menu custom-scroll table-dropdown",
                  disabled: _ctx.state.ui.isLoading.isShow
                }, [
                  (_ctx.userRole === 1)
                    ? (_openBlock(), _createBlock("a", {
                        key: 0,
                        class: "dropdown-item border-bottom text-success",
                        href: "javascript:void(0)",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addNewUnit(null)))
                      }, "+ " + _toDisplayString(_ctx.$t('add_new_role')), 1))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.roles, (role, roleIndex) => {
                    return (_openBlock(), _createBlock("a", {
                      class: "dropdown-item with-actions",
                      href: "javascript:void(0)",
                      key: roleIndex
                    }, [
                      _createVNode("span", {
                        class: "unit-title d-block",
                        onClick: ($event: any) => (_ctx.selectUnit(member, role))
                      }, _toDisplayString(role.name), 9, ["onClick"]),
                      _createVNode("span", _hoisted_14, [
                        (_ctx.userRole === 1)
                          ? (_openBlock(), _createBlock("span", {
                              key: 0,
                              class: "actions-text",
                              onClick: ($event: any) => (_ctx.editRole(role))
                            }, [
                              _hoisted_15
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (_ctx.userRole === 1)
                          ? (_openBlock(), _createBlock("span", {
                              key: 1,
                              class: "actions-text ml-2",
                              onClick: ($event: any) => (_ctx.showDeleteRole(role))
                            }, [
                              _hoisted_16
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ], 8, ["disabled"])
              ])
            ]),
            (member.role && member.role.permissions && member.role.permissions.length)
              ? (_openBlock(), _createBlock("div", _hoisted_17, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(member.role.permissions, (permission, permissionIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      key: `permi-${memberIndex}-${permissionIndex}`
                    }, [
                      (_ctx.activeTab === 'phase')
                        ? (_openBlock(), _createBlock("div", _hoisted_18, [
                            (permission.id === 8 || permission.id === 6 || permission.id === 3 || permission.id === 2 || permission.id === 1 || permission.id === 7)
                              ? (_openBlock(), _createBlock("div", _hoisted_19, [
                                  _withDirectives(_createVNode("input", {
                                    class: "form-check-input mt-0 ml-0",
                                    type: "checkbox",
                                    id: `permissionChecked${permissionIndex}`,
                                    "onUpdate:modelValue": ($event: any) => (permission.isChecked = $event),
                                    onClick: ($event: any) => (_ctx.permissionByUser(permission, member))
                                  }, null, 8, ["id", "onUpdate:modelValue", "onClick"]), [
                                    [_vModelCheckbox, permission.isChecked]
                                  ]),
                                  (permission && permission.name)
                                    ? (_openBlock(), _createBlock("label", {
                                        key: 0,
                                        class: "form-check-label ml-3",
                                        for: `permissionChecked${permissionIndex}`
                                      }, [
                                        _createVNode("small", _hoisted_20, _toDisplayString(permission.name), 1)
                                      ], 8, ["for"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_21, [
                            ( permission.id === 4 || permission.id === 5)
                              ? (_openBlock(), _createBlock("div", _hoisted_22, [
                                  _withDirectives(_createVNode("input", {
                                    class: "form-check-input mt-0 ml-0",
                                    type: "checkbox",
                                    id: `permissionChecked${permissionIndex}`,
                                    "onUpdate:modelValue": ($event: any) => (permission.isChecked = $event)
                                  }, null, 8, ["id", "onUpdate:modelValue"]), [
                                    [_vModelCheckbox, permission.isChecked]
                                  ]),
                                  (permission && permission.name)
                                    ? (_openBlock(), _createBlock("label", {
                                        key: 0,
                                        class: "form-check-label ml-3",
                                        for: `permissionChecked${permissionIndex}`
                                      }, [
                                        _createVNode("small", _hoisted_23, _toDisplayString(permission.name), 1)
                                      ], 8, ["for"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_24, [
            _createVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('amount_type')), 1),
            _createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                _createVNode("div", _hoisted_28, [
                  _createVNode("div", _hoisted_29, [
                    _createVNode("a", {
                      class: "dropdown-toggle d-block border rounded py-2 px-3",
                      type: "button",
                      "data-toggle": "dropdown",
                      "aria-expanded": "false",
                      disabled: _ctx.state.ui.isLoading.isShow
                    }, [
                      _createVNode("span", _hoisted_30, _toDisplayString(member.amountType.id
                    ? member.amountType.name
                    : _ctx.$t('choose_amount_type')), 1)
                    ], 8, ["disabled"]),
                    _createVNode("div", {
                      class: "dropdown-menu custom-scroll table-dropdown",
                      disabled: _ctx.state.ui.isLoading.isShow
                    }, [
                      (_ctx.userRole === 1)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            class: "dropdown-item border-bottom text-success",
                            href: "javascript:void(0)",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addAmountType(null)))
                          }, "+ " + _toDisplayString(_ctx.$t('add_new_amount_type')), 1))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.amountTypes, (amount, amountIndex) => {
                        return (_openBlock(), _createBlock("a", {
                          class: "dropdown-item with-actions",
                          href: "javascript:void(0)",
                          key: amountIndex
                        }, [
                          _createVNode("span", {
                            class: "unit-title d-block",
                            onClick: ($event: any) => (_ctx.selectAmountType(member, amount))
                          }, _toDisplayString(amount.name), 9, ["onClick"]),
                          _createVNode("span", _hoisted_31, [
                            (_ctx.userRole === 1)
                              ? (_openBlock(), _createBlock("span", {
                                  key: 0,
                                  class: "actions-text",
                                  onClick: ($event: any) => (_ctx.editAmountType(amount))
                                }, [
                                  _hoisted_32
                                ], 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.userRole === 1)
                              ? (_openBlock(), _createBlock("span", {
                                  key: 1,
                                  class: "actions-text ml-2",
                                  onClick: ($event: any) => (_ctx.showDeleteAmountType(amount))
                                }, [
                                  _hoisted_33
                                ], 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ], 8, ["disabled"])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_34, [
                _createVNode("div", _hoisted_35, [
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control",
                    placeholder: "$0.00",
                    "onUpdate:modelValue": ($event: any) => (member.amountTypeNumber = $event)
                  }, null, 8, ["onUpdate:modelValue"]), [
                    [_vModelText, member.amountTypeNumber]
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_36, [
            _createVNode("button", {
              class: "btn default-btn btn-sm",
              disabled: !member.email,
              onClick: ($event: any) => (_ctx.showAvaibilityModalByUser(member, memberIndex))
            }, _toDisplayString(_ctx.$t('check_availability')), 9, ["disabled", "onClick"])
          ]),
          _createVNode("div", _hoisted_37, [
            _createVNode("div", _hoisted_38, [
              _createVNode("label", null, [
                _withDirectives(_createVNode("input", {
                  type: "checkbox",
                  name: "agree",
                  id: "agree-checkbox",
                  "onUpdate:modelValue": ($event: any) => (member.approval_required = $event)
                }, null, 8, ["onUpdate:modelValue"]), [
                  [_vModelCheckbox, member.approval_required]
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('approval_required')), 1)
              ])
            ])
          ])
        ]),
        (member.filteredSlots && member.filteredSlots.length)
          ? (_openBlock(), _createBlock("div", _hoisted_39, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(member.filteredSlots, (time, timeIndex) => {
                return (_openBlock(), _createBlock("div", {
                  class: "col-md-4",
                  key: timeIndex
                }, [
                  _createVNode("div", {
                    class: "shadowed-card bg-white mt-1 left-colored-border",
                    style: `border-left-color: ${time.bgColor};`
                  }, [
                    (_ctx.isShowDeleteSlot)
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          class: "remove-btnn",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.deleteSelectedTimeSlot(memberIndex, time))
                        }, [
                          _hoisted_40
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_41, [
                      (time.title)
                        ? (_openBlock(), _createBlock("p", _hoisted_42, [
                            _createVNode("strong", null, _toDisplayString(time.title) + ":", 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_43, [
                        (time.formatedStart)
                          ? (_openBlock(), _createBlock("div", _hoisted_44, [
                              _createVNode("p", null, [
                                _createVNode("small", null, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('start_date_time')) + ":", 1)
                                ])
                              ]),
                              _createVNode("p", _hoisted_45, [
                                _createVNode("small", null, _toDisplayString(time.formatedStart), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (time.formatedEnd)
                          ? (_openBlock(), _createBlock("div", _hoisted_46, [
                              _createVNode("p", null, [
                                _createVNode("small", null, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('end_date_time')) + ":", 1)
                                ])
                              ]),
                              _createVNode("p", _hoisted_47, [
                                _createVNode("small", null, _toDisplayString(time.formatedEnd), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (time.isAllday)
                        ? (_openBlock(), _createBlock("div", _hoisted_48, [
                            _createVNode("div", _hoisted_49, [
                              _createVNode("p", _hoisted_50, [
                                _createVNode("small", null, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('all_day')), 1)
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 4)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.isShowDeleteMember)
          ? (_openBlock(), _createBlock("div", _hoisted_51, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn btn-sm red-btn",
                onClick: ($event: any) => (_ctx.selectedMember(member))
              }, [
                _hoisted_52,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
              ], 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createVNode("div", _hoisted_53, [
      _createVNode("div", _hoisted_54, [
        _createVNode("div", _hoisted_55, [
          _createVNode("div", _hoisted_56, [
            _createVNode("div", _hoisted_57, [
              (_ctx.state.ui.isLoading.isRoleEdit)
                ? (_openBlock(), _createBlock("h5", _hoisted_58, _toDisplayString(_ctx.$t('update_role')), 1))
                : (_openBlock(), _createBlock("h5", _hoisted_59, _toDisplayString(_ctx.$t('add_role')), 1)),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addUniteClose && _ctx.addUniteClose(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_60
              ])
            ]),
            _createVNode("div", _hoisted_61, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.error.errorList.createRole,
                hasError: _ctx.state.ui.error.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_62, [
                _createVNode("label", _hoisted_63, _toDisplayString(_ctx.$t('name')), 1),
                _withDirectives(_createVNode("input", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.unit.name = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.unit.name]
                ])
              ]),
              (_ctx.state.data.unit.permissionList && _ctx.state.data.unit.permissionList.length)
                ? (_openBlock(), _createBlock("div", _hoisted_64, [
                    _createVNode("label", _hoisted_65, _toDisplayString(_ctx.$t('phase_permissions')), 1),
                    _createVNode("div", _hoisted_66, [
                      _createVNode("ul", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.unit.permissionList, (permission, permissionIndex) => {
                          return (_openBlock(), _createBlock("li", {
                            class: "mr-2",
                            key: `perm${permissionIndex}`
                          }, [
                            (permission.id === 8 || permission.id === 6 || permission.id === 3 || permission.id === 2 || permission.id === 1 || permission.id === 7)
                              ? (_openBlock(), _createBlock("div", _hoisted_67, [
                                  _withDirectives(_createVNode("input", {
                                    class: "form-check-input ml-0",
                                    type: "checkbox",
                                    id: `permission${permissionIndex}`,
                                    "onUpdate:modelValue": ($event: any) => (permission.isChecked = $event)
                                  }, null, 8, ["id", "onUpdate:modelValue"]), [
                                    [_vModelCheckbox, permission.isChecked]
                                  ]),
                                  (permission && permission.name)
                                    ? (_openBlock(), _createBlock("label", {
                                        key: 0,
                                        class: "form-check-label ml-3",
                                        for: `permission${permissionIndex}`
                                      }, [
                                        _createVNode("small", _hoisted_68, _toDisplayString(permission.name), 1)
                                      ], 8, ["for"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.data.unit.permissionList && _ctx.state.data.unit.permissionList.length)
                ? (_openBlock(), _createBlock("div", _hoisted_69, [
                    _createVNode("label", _hoisted_70, _toDisplayString(_ctx.$t('task_permissions')), 1),
                    _createVNode("div", _hoisted_71, [
                      _createVNode("ul", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.unit.permissionList, (permission, permissionIndex) => {
                          return (_openBlock(), _createBlock("li", {
                            class: "mr-2",
                            key: `perm${permissionIndex}`
                          }, [
                            ( permission.id === 4 || permission.id === 5)
                              ? (_openBlock(), _createBlock("div", _hoisted_72, [
                                  _withDirectives(_createVNode("input", {
                                    class: "form-check-input ml-0",
                                    type: "checkbox",
                                    id: `permission${permissionIndex}`,
                                    "onUpdate:modelValue": ($event: any) => (permission.isChecked = $event)
                                  }, null, 8, ["id", "onUpdate:modelValue"]), [
                                    [_vModelCheckbox, permission.isChecked]
                                  ]),
                                  (permission && permission.name)
                                    ? (_openBlock(), _createBlock("label", {
                                        key: 0,
                                        class: "form-check-label ml-3",
                                        for: `permission${permissionIndex}`
                                      }, [
                                        _createVNode("small", _hoisted_73, _toDisplayString(permission.name), 1)
                                      ], 8, ["for"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_74, [
              (_ctx.state.ui.isLoading.isRoleEdit)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.updateRole && _ctx.updateRole(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.createRole ? _ctx.$t('loading1') : _ctx.$t('update')), 1))
                : (_openBlock(), _createBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.createRole && _ctx.createRole(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.createRole ? _ctx.$t('loading1') : _ctx.$t('save')), 1)),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addUniteClose && _ctx.addUniteClose(...args)))
              }, _toDisplayString(_ctx.$t('cancel')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_75, [
      _createVNode("div", _hoisted_76, [
        _createVNode("div", _hoisted_77, [
          _createVNode("div", _hoisted_78, [
            _createVNode("div", _hoisted_79, [
              (_ctx.state.ui.isLoading.isAmountTypeEdit)
                ? (_openBlock(), _createBlock("h5", _hoisted_80, _toDisplayString(_ctx.$t('update_amount_type')), 1))
                : (_openBlock(), _createBlock("h5", _hoisted_81, _toDisplayString(_ctx.$t('add_amount_type')), 1)),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.hideAmountTypeModal && _ctx.hideAmountTypeModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_82
              ])
            ]),
            _createVNode("div", _hoisted_83, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.error.errorList.createAmountType,
                hasError: _ctx.state.ui.error.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_84, [
                _createVNode("label", _hoisted_85, _toDisplayString(_ctx.$t('name')), 1),
                _withDirectives(_createVNode("input", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.data.unit.name = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.unit.name]
                ])
              ]),
              _createVNode("div", _hoisted_86, [
                _createVNode("label", _hoisted_87, _toDisplayString(_ctx.$t('type')), 1),
                _withDirectives(_createVNode("select", {
                  class: "form-control w-100",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.data.unit.selectedAmountType = $event))
                }, [
                  _createVNode("option", _hoisted_88, _toDisplayString(_ctx.$t('click_to_select_type')), 1),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.unit.amount_depends, (amount, amountIndex) => {
                    return (_openBlock(), _createBlock("option", {
                      value: amount.id,
                      key: amountIndex
                    }, _toDisplayString(_ctx.state.ui.isLoading.isAmountTypeEdit && amount.ischecked ? amount.name : amount.name), 9, ["value"]))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.state.data.unit.selectedAmountType]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_89, [
              (_ctx.state.ui.isLoading.isAmountTypeEdit)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.updateAmountType && _ctx.updateAmountType(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.createAmountType ? _ctx.$t('loading1') : _ctx.$t('update')), 1))
                : (_openBlock(), _createBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.createAmountType && _ctx.createAmountType(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.createAmountType ? _ctx.$t('loading1') : _ctx.$t('save')), 1)),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.hideAmountTypeModal && _ctx.hideAmountTypeModal(...args)))
              }, _toDisplayString(_ctx.$t('cancel')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_90, [
      _createVNode("div", _hoisted_91, [
        _createVNode("div", _hoisted_92, [
          _createVNode("div", _hoisted_93, [
            _createVNode("div", _hoisted_94, [
              _createVNode("h5", _hoisted_95, _toDisplayString(_ctx.$t('delete')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteRole && _ctx.hideDeleteRole(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_96
              ])
            ]),
            _createVNode("div", _hoisted_97, [
              _createVNode("div", _hoisted_98, _toDisplayString(_ctx.$t('are_you_sure_you_want_to_delete')), 1)
            ]),
            _createVNode("div", _hoisted_99, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.deletePhaseRole && _ctx.deletePhaseRole(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.phaseRoleDelete ? _ctx.$t('loading1') : _ctx.$t('yes')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteRole && _ctx.hideDeleteRole(...args)))
              }, _toDisplayString(_ctx.$t('no')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_100, [
      _createVNode("div", _hoisted_101, [
        _createVNode("div", _hoisted_102, [
          _createVNode("div", _hoisted_103, [
            _createVNode("div", _hoisted_104, [
              _createVNode("h5", _hoisted_105, _toDisplayString(_ctx.$t('delete')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteAmountType && _ctx.hideDeleteAmountType(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_106
              ])
            ]),
            _createVNode("div", _hoisted_107, [
              _createVNode("div", _hoisted_108, _toDisplayString(_ctx.$t('are_you_sure_delete')), 1)
            ]),
            _createVNode("div", _hoisted_109, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.deletePhaseAmountType && _ctx.deletePhaseAmountType(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.amountTypeDelete ? _ctx.$t('loading1') : _ctx.$t('yes')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteAmountType && _ctx.hideDeleteAmountType(...args)))
              }, _toDisplayString(_ctx.$t('no')), 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ], 64))
}